import React, { useCallback, useMemo, useState } from 'react'

export const useMulControlledInput = ({ initialValue = {}, schema = {} }) => {
  const [values, setValues] = useState(initialValue)
  const [errors, setErrors] = useState({})

  const handleError = useCallback(({ name, value }) => {
    const error = schema?.[name]?.validate(value)
    if (error) {
      setErrors((prev) => ({
        ...prev,
        [name]: error,
      }))
    } else {
      setErrors((prev) => {
        const newErrors = { ...prev }
        delete newErrors[name]
        return newErrors
      })
    }
  }, [])

  const onChange = useCallback(
    (event) => {
      const { name, value } = event.target
      setValues((prev) => ({
        ...prev,
        [name]: value,
      }))
      handleError({ name, value })
    },
    [handleError]
  )

  const onBlur = useCallback(
    (event) => {
      const { name, value } = event.target
      handleError({ name, value })
    },
    [handleError]
  )

  const validateForm = useCallback(() => {
    const newErrors = {}
    Object.keys(schema).forEach((key) => {
      const error = schema[key]?.validate(values[key])
      if (error) {
        newErrors[key] = error
      } else {
        delete newErrors[key]
      }
    })
    setErrors(newErrors)
    return newErrors
  }, [schema, values])

  const isValid = useMemo(() => Object.keys(errors).length === 0, [errors])

  const isDirty = useMemo(() => JSON.stringify(values) !== JSON.stringify(initialValue), [values, initialValue])

  return {
    values,
    setValues,
    errors,
    setErrors,
    onChange,
    onBlur,
    validateForm,
    handleError,
    isValid,
    isDirty,
  }
}
